import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { OutputAnalyticsReportItem } from '@portal-core/output-analytics/models/output-analytics-report-item.model';

@CollectionStateSelectors({
  stateType: OutputAnalyticsReportItemState
})
@State<OutputAnalyticsReportItemState>({
  name: OutputAnalyticsReportItemState.source,
})
@Service({ autoProvided: false })
export class OutputAnalyticsReportItemState extends CollectionStateBase {
  static override source = 'OutputAnalyticsReportItems';
  getSource(): string {
    return OutputAnalyticsReportItemState.source;
  }
}

@Service()
export class OutputAnalyticsReportItemDataService extends CollectionDataServiceBase<OutputAnalyticsReportItem> {
  protected readonly stateType = OutputAnalyticsReportItemState;
}
